export const tableList = [
  'header',
  'forecast',
  'consensus',
  'forecast_yoy',
  'consensus_yoy',
  'forecast_error',
];

export const tableNames = {
  header: undefined,
  forecast: 'Apptopia Forecast',
  consensus: 'Consensus',
  forecast_yoy: 'YoY Apptopia Forecast',
  consensus_yoy: 'YoY Consensus',
  forecast_error: 'Forecast % Error',
};
